module.exports = __webpack_public_path__ + "static/media/park-box5.2577d4f5.png";